module.exports = __webpack_public_path__ + "img/home-outline_active.svg";